<template>
  <router-link
    :to="{name: 'contest_info', params: {contestId: contestId}}"
  >{{text}}</router-link>
</template>

<script>
export default {
  name: 'ContestLink',

  props: {
    contestId: {
      type: Number,
      required: true,
    },

    label: {
      type: String,
      default: 'contest',
    }
  },

  computed: {
    /** @returns {string} */
    text() {
      const label = this.label;
      const idStr = this.contestId.toString();

      if(label.length > 0) {
        return label + ' ' + idStr;
      } else {
        return idStr;
      }
    },
  },
};
</script>
